// TODO: Move to checkout-utils
export enum ContentType {
  Json = 'application/json',
}
